import { render, staticRenderFns } from "./SwapRequest.vue?vue&type=template&id=2e7cb15c&"
import script from "./SwapRequest.vue?vue&type=script&lang=js&"
export * from "./SwapRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports